import { useState, useEffect } from 'react';

interface HeroSectionProps {
  onScrollToOffer: () => void;
}

export default function HeroSection({ onScrollToOffer }: HeroSectionProps) {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    if (document.fonts) {
      document.fonts.ready.then(() => {
        setFontsLoaded(true);
      });
    } else {
      setFontsLoaded(true);
    }
  }, []);

  const fontFamily = fontsLoaded ? 'Montserrat, sans-serif' : '-apple-system, BlinkMacSystemFont, sans-serif';
  const fontFamilyInter = fontsLoaded ? 'Inter, sans-serif' : '-apple-system, BlinkMacSystemFont, sans-serif';

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-16 sm:pt-20 px-4 sm:px-6">
      {/* Background com overlay - apenas desktop */}
      <div 
        className="hidden sm:block absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=luxury%20dark%20background%20with%20golden%20energy%20particles%20flowing%20upward%2C%20premium%20black%20metallic%20surface%20with%20subtle%20gold%20light%20rays%20and%20diamond%20sparkles%2C%20cinematic%20atmospheric%20lighting%20with%20depth%20and%20dimension&width=1920&height=1080&seq=hero-premium-bg&orientation=landscape')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black sm:from-black/70 sm:via-black/50" />
      
      {/* Brilho dourado central - apenas desktop */}
      <div className="hidden sm:flex absolute inset-0 items-center justify-center">
        <div className="w-[800px] h-[800px] bg-gradient-radial from-yellow-500/10 via-transparent to-transparent rounded-full blur-3xl" />
      </div>
      
      <div className="relative z-10 text-center max-w-6xl mx-auto py-12 sm:py-20">
        {/* Título principal */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6 sm:mb-8 leading-[0.95] tracking-tight" style={{ fontFamily }}>
          <span className="block text-yellow-400 sm:bg-gradient-to-r sm:from-yellow-200 sm:via-yellow-400 sm:to-yellow-600 sm:bg-clip-text sm:text-transparent drop-shadow-2xl">
            O CÓDIGO
          </span>
          <span className="block text-white mt-2">
            DA MENTALIDADE
          </span>
          <span className="block text-yellow-500 sm:bg-gradient-to-r sm:from-yellow-400 sm:via-yellow-500 sm:to-yellow-600 sm:bg-clip-text sm:text-transparent">
            MILIONÁRIA
          </span>
        </h1>
        
        {/* Subtítulo */}
        <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl mb-6 sm:mb-12 text-gray-300 leading-relaxed max-w-4xl mx-auto font-light px-4" style={{ fontFamily: fontFamilyInter }}>
          Desbloqueie o código que separa quem vive na escassez de quem <span className="text-yellow-400 font-semibold">atrai riqueza</span>
        </p>
        
        {/* CTA Principal */}
        <button 
          onClick={onScrollToOffer}
          className="group relative w-full sm:w-auto bg-gradient-to-r from-yellow-400 to-yellow-600 text-black px-6 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg md:text-xl font-bold hover:from-yellow-500 hover:to-yellow-700 transform sm:hover:scale-105 transition-all duration-300 shadow-xl sm:shadow-2xl shadow-yellow-500/40 cursor-pointer max-w-md mx-auto"
          style={{ fontFamily }}
        >
          <span className="relative z-10 flex items-center justify-center gap-2 sm:gap-3">
            <i className="ri-lock-unlock-line text-xl sm:text-2xl"></i>
            <span className="text-center leading-tight">DESBLOQUEAR MINHA MENTE</span>
          </span>
          <div className="hidden sm:block absolute inset-0 bg-gradient-to-r from-yellow-300 to-yellow-500 rounded-full opacity-0 group-hover:opacity-100 blur-xl transition-opacity duration-300" />
        </button>
      </div>
    </section>
  );
}
